import { createContext, useContext } from 'react';

interface CalendarNavContextValue {
  navigateToWeek: (date: Date) => void;
}

export const CalendarNavContext = createContext<CalendarNavContextValue>({
  navigateToWeek: () => {},
});

export const useCalendarNav = () => useContext(CalendarNavContext);
